
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import SEOHead from '../../../components/SEO/SEOHead';
import Button from '../../../components/base/Button';

export default function Product4Page() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedImage, setSelectedImage] = useState(0);

  const seoData = {
    title: 'توری ضد حشره - ضد تریپس | گلخانه سبز آریا',
    description: 'انواع توری‌های ضد حشره و ضد تریپس وارداتی از کشورهای ایتالیا و چین. توری ضد تریپس عرض ۱.۵ تا ۲.۵ در طول های ۱۰۰ و ۲۰۰متر با کیفیت بالا و مقاومت در برابر UV',
    keywords: 'توری ضد حشره، توری ضد تریپس، توری ایتالیا، توری آریگونی، خدمات گلخانه، طراحی گلخانه هوشمند، ساخت گلخانه، اتوماسیون گلخانه، مشاوره کشاورزی، نگهداری گلخانه، پشتیبانی فنی',
    ogImage: 'https://public.readdy.ai/ai/img_res/16fcd1d463c49ba534b0cfd95dbd1cd0.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "توری ضد حشره - ضد تریپس",
      "description": "انواع توری‌های ضد حشره و ضد تریپس وارداتی از کشورهای ایتالیا و چین. توری ضد تریپس عرض ۱.۵ تا ۲.۵ در طول های ۱۰۰ و ۲۰۰متر با کیفیت بالا و مقاومت در برابر UV",
      "image": "https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture&width=800&height=600&seq=product4-schema&orientation=landscape",
      "sku": "THRIPS-NET-001",
      "mpn": "TN-001-2024",
      "brand": {
        "@type": "Brand",
        "name": "گلخانه سبز آریا",
        "url": "https://greenhouse-aria.com"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا"
      },
      "category": "تجهیزات گلخانه",
      "offers": {
        "@type": "Offer",
        "url": "https://greenhouse-aria.com/products/4",
        "priceCurrency": "IRR",
        "price": "120000",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "itemCondition": "https://schema.org/NewCondition",
        "seller": {
          "@type": "Organization",
          "name": "گلخانه سبز آریا"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "24",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "احمد محمدی"
          },
          "reviewBody": "کیفیت عالی و مقاوم در برابر آفات. توصیه می‌کنم."
        }
      ]
    }
  };

  const product = {
    id: 4,
    name: 'توری ضد حشره - ضد تریپس',
    category: 'protection',
    price: '۱۲۰,۰۰۰ تومان',
    originalPrice: '۱۵۰,۰۰۰ تومان',
    images: [
      'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture%20close%20up%20view&width=600&height=600&seq=thrips-detail1&orientation=squarish',
      'https://readdy.ai/api/search-image?query=anti-thrips%20mesh%20installation%20in%20greenhouse%20covering%20plants%20protective%20netting%20agricultural%20application%20professional%20setup&width=600&height=600&seq=thrips-detail2&orientation=squarish',
      'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20anti-thrips%20mesh%20texture%20showing%20fine%20weave%20pattern%20protective%20agricultural%20netting%20material%20detail&width=600&height=600&seq=thrips-detail3&orientation=squarish',
      'https://readdy.ai/api/search-image?query=anti-thrips%20net%20roll%20packaging%20professional%20agricultural%20product%20white%20background%20industrial%20photography&width=600&height=600&seq=thrips-detail4&orientation=squarish'
    ],
    shortDescription: 'توری محافظ در برابر حشرات مضر گلخانه',
    fullDescription: 'توری ضد تریپس ما یک توری محافظ با کیفیت بالا است که به طور خاص برای کاربردهای گلخانه‌ای طراحی شده است. این توری ریز که از مواد پلی‌اتیلن بادوام ساخته شده، محافظت عالی در برابر تریپس و سایر حشرات کوچک فراهم می‌کند و در عین حال تهویه بهینه و عبور نور را برای رشد سالم گیاهان حفظ می‌کند.',
    features: [
      'محافظت از تریپس',
      'تهویه مناسب',
      'عبور نور',
      'مقاوم در برابر UV',
      'نصب آسان',
      'مواد بادوام',
      'مقاوم در برابر آب و هوا',
      'قابل استفاده مجدد'
    ],
    specifications: {
      'ابعاد': '۲×۱۰ متر',
      'اندازه چشمه': '۰.۱۵×۰.۳۵ میلی‌متر',
      'رنگ': 'سفید',
      'مواد': 'پلی‌اتیلن (PE)',
      'محافظت UV': '۵-۸ درصد',
      'وزن': '۱۵۰ گرم بر متر مربع',
      'محدوده دما': '۲۰- تا ۸۰+ درجه سانتی‌گراد',
      'گارانتی': '۲ سال',
      'مدل چینی - عرض': '۱.۵ / ۲ / ۲.۵ متر',
      'مدل چینی - طول': '۱۰۰ متر',
      'مدل ایتالیایی - عرض': '۱.۸ / ۲.۳ متر',
      'مدل ایتالیایی - طول': '۲۰۰ متر'
    },
    applications: [
      'محافظت گلخانه',
      'پوشش نهالستان',
      'محافظت محصولات',
      'سیستم‌های تهویه',
      'خانه‌های توری',
      'تونل‌های کشاورزی'
    ],
    installation: [
      'منطقه نصب را به طور کامل تمیز کنید',
      'توری را اندازه‌گیری و به اندازه مورد نیاز برش دهید',
      'توری را با استفاده از گیره یا بست محکم کنید',
      'کشش مناسب را برای عملکرد بهینه تضمین کنید',
      'هرگونه شکاف یا نقاط شل را بررسی کنید',
      'نگهداری و تمیزکاری منظم انجام دهید'
    ],
    benefits: [
      'آسیب آفات را تا ۹۵٪ کاهش می‌دهد',
      'تهویه طبیعی را حفظ می‌کند',
      '۸۵٪ نور را عبور می‌دهد',
      'فصل رشد محصول را تمدید می‌کند',
      'استفاده از آفت‌کش را کاهش می‌دهد',
      'کیفیت و عملکرد محصول را بهبود می‌بخشد'
    ],
    inStock: true,
    stockQuantity: 50,
    rating: 4.8,
    reviewCount: 24
  };

  const tabs = [
    { id: 'overview', name: 'نمای کلی', icon: 'ri-information-line' },
    { id: 'specifications', name: 'مشخصات فنی', icon: 'ri-settings-3-line' },
    { id: 'installation', name: 'نحوه نصب', icon: 'ri-tools-line' },
    { id: 'applications', name: 'کاربردها', icon: 'ri-plant-line' },
    { id: 'benefits', name: 'مزایا', icon: 'ri-award-line' }
  ];

  const relatedProducts = [
    {
      id: 1,
      name: 'کوکوپیت پریمیوم',
      price: '۲۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography&width=300&height=200&seq=related1&orientation=landscape'
    },
    {
      id: 2,
      name: 'نخ UV گلخانه',
      price: '۸۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography&width=300&height=200&seq=related2&orientation=landscape'
    },
    {
      id: 3,
      name: 'چسب ترمیم پلاستیک',
      price: '۴۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality%20white%20background%20product%20photography&width=300&height=200&seq=related3&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography%20detailed%20texture&width=1920&height=600&seq=product4-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            توری ضد حشره - ضد تریپس
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            محافظت در برابر حشرات مضر گلخانه
          </p>
        </div>
      </section>

      {/* Product Detail */}
      <section className="py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Product Images */}
            <div className="space-y-4">
              <div className="relative">
                <img
                  src={product.images[selectedImage]}
                  alt={product.name}
                  className="w-full h-96 object-cover object-top rounded-3xl shadow-lg"
                />
                {!product.inStock && (
                  <div className="absolute inset-0 bg-black/50 rounded-3xl flex items-center justify-center">
                    <span className="bg-red-600 text-white px-6 py-2 rounded-full font-bold">ناموجود</span>
                  </div>
                )}
              </div>
              <div className="grid grid-cols-4 gap-2">
                {product.images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`relative rounded-2xl overflow-hidden cursor-pointer ${
                      selectedImage === index ? 'ring-2 ring-emerald-500' : ''
                    }`}
                  >
                    <img
                      src={image}
                      alt={`${product.name} ${index + 1}`}
                      className="w-full h-20 object-cover object-top"
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div className="space-y-6">
              <div>
                <h1 className="text-3xl font-bold text-gray-800 mb-2">{product.name}</h1>
                <p className="text-gray-600 text-lg">{product.shortDescription}</p>
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-4">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-lg ${
                        i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-300'
                      }`}
                    ></i>
                  ))}
                  <span className="mr-2 text-gray-600">({product.rating})</span>
                </div>
                <span className="text-gray-500">{product.reviewCount} نظر</span>
              </div>

              {/* Price */}
              <div className="flex items-center space-x-4">
                <span className="text-3xl font-bold text-emerald-600">{product.price}</span>
                <span className="text-xl text-gray-500 line-through">{product.originalPrice}</span>
                <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-medium">
                  ۲۰٪ تخفیف
                </span>
              </div>

              {/* Key Features */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">ویژگی‌های کلیدی</h3>
                <div className="grid grid-cols-2 gap-2">
                  {product.features.slice(0, 6).map((feature, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <i className="ri-check-line text-emerald-600"></i>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* مشخصات فنی */}
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">جنس</span>
                  <span className="text-gray-600">PE (پلی‌اتیلن)</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">محافظت UV</span>
                  <span className="text-gray-600">۵-۸ درصد</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">مدل چینی</span>
                  <span className="text-gray-600">عرض ۱.۵، ۲، ۲.۵ متر - طول ۱۰۰ متر</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                  <span className="font-medium text-gray-800">مدل ایتالیایی</span>
                  <span className="text-gray-600">عرض ۱.۸، ۲.۳ متر - طول ۲۰۰ متر</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="space-y-4">
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button size="lg" className="flex-1">
                    <i className="ri-phone-line ml-2"></i>
                    استعلام قیمت
                  </Button>
                  <Button variant="outline" size="lg" className="flex-1">
                    <i className="ri-heart-line ml-2"></i>
                    افزودن به علاقه‌مندی‌ها
                  </Button>
                </div>
              </div>

              {/* Contact Info */}
              <div className="bg-emerald-50 p-6 rounded-3xl">
                <h4 className="font-semibold text-gray-800 mb-3">نیاز به مشاوره دارید؟</h4>
                <p className="text-gray-600 mb-4">کارشناسان ما آماده پاسخگویی به سوالات شما هستند</p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button size="sm" className="flex-1">
                    <i className="ri-phone-line ml-2"></i>
                    تماس تلفنی
                  </Button>
                  <Button variant="outline" size="sm" className="flex-1">
                    <i className="ri-message-3-line ml-2"></i>
                    چت آنلاین
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Details Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-emerald-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-emerald-50 border border-gray-200'
                }`}
              >
                <i className={`${tab.icon} text-lg`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-3xl p-8 shadow-lg">
            {activeTab === 'overview' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">درباره محصول</h3>
                <p className="text-gray-700 leading-relaxed text-lg">{product.fullDescription}</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-4">ویژگی‌های کلیدی</h4>
                    <div className="space-y-3">
                      {product.features.map((feature, index) => (
                        <div key={index} className="flex items-center space-x-3">
                          <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
                            <i className="ri-check-line text-emerald-600 text-sm"></i>
                          </div>
                          <span className="text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-4">مزایای استفاده</h4>
                    <div className="space-y-3">
                      {product.benefits.slice(0, 4).map((benefit, index) => (
                        <div key={index} className="flex items-start space-x-3">
                          <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-0.5">
                            <i className="ri-star-line text-blue-600 text-sm"></i>
                          </div>
                          <span className="text-gray-700">{benefit}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مشخصات فنی</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {Object.entries(product.specifications).map(([key, value]) => (
                    <div key={key} className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl">
                      <span className="font-medium text-gray-800">{key}</span>
                      <span className="text-gray-600">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'installation' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">راهنمای نصب</h3>
                <div className="space-y-4">
                  {product.installation.map((step, index) => (
                    <div key={index} className="flex items-start space-x-4 p-4 bg-gray-50 rounded-2xl">
                      <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                        {index + 1}
                      </div>
                      <p className="text-gray-700 flex-1">{step}</p>
                    </div>
                  ))}
                </div>
                
                <div className="mt-8 p-6 bg-yellow-50 rounded-3xl border border-yellow-200">
                  <div className="flex items-start space-x-3">
                    <i className="ri-information-line text-yellow-600 text-xl mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-yellow-800 mb-2">نکته مهم</h4>
                      <p className="text-yellow-700">برای نصب صحیح و بهینه، توصیه می‌شود از کارشناسان فنی ما کمک بگیرید. خدمات نصب و راه‌اندازی ما شامل گارانتی کامل می‌باشد.</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'applications' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">کاربردها</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {product.applications.map((application, index) => (
                    <div key={index} className="bg-gradient-to-br from-emerald-50 to-blue-50 p-6 rounded-3xl border border-emerald-100">
                      <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                        <i className="ri-plant-line text-emerald-600 text-xl"></i>
                      </div>
                      <h4 className="font-semibold text-gray-800 mb-2">{application}</h4>
                      <p className="text-gray-600 text-sm">مناسب برای استفاده در {application} با کیفیت و دوام بالا</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'benefits' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مزایا و فواید</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {product.benefits.map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-4 p-6 bg-gradient-to-r from-emerald-50 to-green-50 rounded-3xl border border-emerald-100">
                      <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-white text-lg"></i>
                      </div>
                      <div>
                        <p className="text-gray-800 font-medium">{benefit}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">محصولات مرتبط</h2>
            <p className="text-gray-600">محصولات دیگری که ممکن است به آن‌ها نیاز داشته باشید</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {relatedProducts.map((relatedProduct) => (
              <div key={relatedProduct.id} className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <img
                  src={relatedProduct.image}
                  alt={relatedProduct.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-800 mb-2">{relatedProduct.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-emerald-600 font-bold text-lg">{relatedProduct.price}</span>
                    <Button size="sm">
                      مشاهده
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-emerald-600">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            آماده خرید هستید؟
          </h2>
          <p className="text-emerald-100 text-lg mb-8">
            برای دریافت مشاوره رایگان و استعلام قیمت با ما تماس بگیرید
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-white text-emerald-600 hover:bg-gray-100">
              <i className="ri-phone-line ml-2"></i>
              تماس برای مشاوره
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-emerald-600">
              <i className="ri-message-3-line ml-2"></i>
              درخواست کاتالوگ
            </Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
